// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c105adea","147":"9fe9b391","156":"097d0179","438":"387cc76a","706":"4b59aa0e","726":"9cbf1550"}[chunkId] + ".chunk.js";
};